module.exports = __webpack_public_path__ + "static/media/menuIconOne.1c155682.svg";